
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class EditableCell extends Vue {
  @Prop({ type: String, default: '' }) text?: string;
  value = this.text;
  editable = false;

  handleChange(e: any) {
    const value = e.target.value;
    this.value = value;
    this.$emit('editInput', this.value);
  }
  check() {
    this.editable = false;
    this.$emit('change', this.value);
  }
  edit() {
    this.editable = true;
    this.$nextTick(function () {
      (this.$refs.input as any).focus();
    });
  }
}
